import React from "react";

/**
 * Multilingual Section Component
 * Handles multilingual input for product name and description
 */
const MultilingualSection = ({
  enableMultiLang,
  selectedLang,
  languages,
  formData,
  disabled,
  onEnableChange,
  onLangChange,
  onFieldChange,
}) => {
  if (!languages || languages.length === 0) {
    return null;
  }

  return (
    <div className="mb-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
      <label className="flex items-center space-x-3 cursor-pointer mb-3">
        <input
          type="checkbox"
          className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer disabled:cursor-not-allowed disabled:opacity-50"
          checked={enableMultiLang}
          onChange={onEnableChange}
          disabled={disabled}
        />
        <span className="text-sm font-semibold text-gray-700">
          Enable Multi-Language Support
        </span>
      </label>

      {enableMultiLang && (
        <div className="space-y-4">
          <div className="flex flex-wrap gap-3">
            {languages.map((lang) => (
              <label
                key={lang.code}
                className="flex items-center space-x-2 cursor-pointer"
              >
                <input
                  type="radio"
                  name="language"
                  value={lang.code}
                  checked={selectedLang === lang.code}
                  onChange={onLangChange}
                  disabled={disabled}
                  className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-2 focus:ring-blue-500 cursor-pointer disabled:cursor-not-allowed disabled:opacity-50"
                />
                <span className="text-sm text-gray-700">{lang.name}</span>
              </label>
            ))}
          </div>

          {selectedLang && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  Product Name ({selectedLang.toUpperCase()})
                </label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors bg-white disabled:bg-gray-100 disabled:cursor-not-allowed"
                  value={formData.productName[selectedLang] || ""}
                  onChange={(e) =>
                    onFieldChange("productName", selectedLang, e.target.value)
                  }
                  disabled={disabled}
                  dir={
                    languages.find((l) => l.code === selectedLang)?.direction ||
                    "ltr"
                  }
                  placeholder={`Enter product name in ${selectedLang}`}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  Description ({selectedLang.toUpperCase()})
                </label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors bg-white disabled:bg-gray-100 disabled:cursor-not-allowed"
                  value={formData.description[selectedLang] || ""}
                  onChange={(e) =>
                    onFieldChange("description", selectedLang, e.target.value)
                  }
                  disabled={disabled}
                  dir={
                    languages.find((l) => l.code === selectedLang)?.direction ||
                    "ltr"
                  }
                  placeholder={`Enter description in ${selectedLang}`}
                />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MultilingualSection;
